@if (state$ | async; as state) {
  <div class="w-full">
    <div class="flex flex-col">
      <div class="flex flex-row justify-between items-center">
        <span>{{(state.updateAvailable
          ? '#PWA.UPDATE.SETTINGS.UPDATE_AVAILABLE'
        : '#PWA.UPDATE.SETTINGS.NO_UPDATE') | translate}}</span>
        @if (state.updateAvailable) {
          <button
            class="soft-button primary"
            [disabled]="state.latestVersionHash === undefined"
            (click)="onActivateUpdate()"
          >{{'#PWA.UPDATE.SETTINGS.ACTIVATE' | translate}}</button>
        }
        @if (!state.updateAvailable && state.latestVersionHash === undefined) {
          <button
            class="soft-button primary"
            (click)="onCheckUpdate()"
          >{{'#PWA.UPDATE.SETTINGS.CHECK' | translate}}</button>
        }
      </div>
      <div class="flex flex-row mt-4">
        <span class="soft-label left">{{'#PWA.UPDATE.SETTINGS.CURRENT_HASH' | translate}}</span>
        @if (!state.loading) {
          <span>{{state.currentVersionHash}}</span>
        } @else {
          <span class="skeleton w-18 h-4"></span>
        }
      </div>
      @if (state.latestVersionHash) {
        <div class="flex flex-row mt-4">
          <span class="soft-label left">{{'#PWA.UPDATE.SETTINGS.NEXT_HASH' | translate}}</span>
          <span>{{state.latestVersionHash}}</span>
        </div>
      }
    </div>
  </div>
}
